export default class PaymentsHeader {
  // NOMBRE TABLA DESARROLLO
  setAndesCompanyOperationId(value) {
    if (!value) throw new Error('andesCompanyOperationId/Nombre tabla desarrollo is required');
    this.andesCompanyOperationId = value || '';
    return this;
  }

  // TASA EMISION
  setEmissionRate(value) {
    if (!value) throw new Error('emissionRate is required');
    this.emissionRate = value || '';
    return this;
  }

  // VALOR CUPON
  setCouponValue(value) {
    if (!value) throw new Error('couponValue is required');
    this.couponValue = value || '';
    return this;
  }

  // NUMERO CUPONES
  setNumberOfCoupons(value) {
    if (!value) throw new Error('numberOfCoupons is required');
    this.numberOfCoupons = value || '';
    return this;
  }

  // TIPO INTERES
  setInterestType(value) {
    if (!value) throw new Error('interestType is required');
    this.interestType = value || '';
    return this;
  }

  // CUPONES GRACIA
  setGraceCoupons(value) {
    if (!value) throw new Error('graceCoupons is required');
    this.graceCoupons = value || '';
    return this;
  }

  // BASE CALCULO
  setCalculationBase(value) {
    if (!value) throw new Error('calculationBase is required');
    this.calculationBase = value || '';
    return this;
  }
}
